import { getLeagueList, getSEO } from '@/api/api';

export default {
    namespaced: true,
    state: {
        LeagueObject: {},
        LeagueList: [],
        SEO: {}
    },
    mutations: {
        setLeagueObject: (state, data) => {
            state.LeagueObject = data;
        },
        setLeagueList: (state, data) => {
            state.LeagueList = data;
        },
        setFootballMatch: (state, data) => {
            state.FootballMatch = data;
        },
        setSEO: (state, data) => {
            state.SEO = data;
        },
    },
    actions: {
        fetchLeagueList({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                getLeagueList(params).then(response => {
                    if (response) {
                        commit('setLeagueList', response)
                    }
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        fetchSEO({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                getSEO(params).then((response) => {
                    let _data = JSON.parse(JSON.stringify(response.data));
                    commit('setSEO', _data)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/leagues.js